// extracted by mini-css-extract-plugin
export var cardContainer = "styles-module__cardContainer___uUovR";